import { render, staticRenderFns } from "./wf-overridable-select-edit.vue?vue&type=template&id=ecfd1ec2&scoped=true&"
import script from "./wf-overridable-select-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-overridable-select-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-overridable-select-edit.vue?vue&type=style&index=0&id=ecfd1ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfd1ec2",
  null
  
)

export default component.exports